import 'maptalks/dist/maptalks.css';
import Map from './map';
import {
  TileLayer,
  OverlayLayer,
  VectorLayer
} from './layers';
import {
  Circle,
  Geometry,
  LineString,
  Marker,
  MultiLineString,
  MultiPoint,
  MultiPolygon,
  Polygon,
} from './geometry';

export {
  Map,
  TileLayer,
  OverlayLayer,
  VectorLayer,
  Circle,
  Geometry,
  LineString,
  Marker,
  MultiLineString,
  MultiPoint,
  MultiPolygon,
  Polygon,
};

export default {
  Map,
  TileLayer,
  OverlayLayer,
  VectorLayer,
  Circle,
  Geometry,
  LineString,
  Marker,
  MultiLineString,
  MultiPoint,
  MultiPolygon,
  Polygon,
};



// WEBPACK FOOTER //
// ./src/index.js